import React from "react";
import { useHistory } from "react-router-dom";
import Link from "@amzn/meridian/link";


export const RouteLink = ({to, children, type}) => {
    const history = useHistory();
    return (
    <Link onClick={() => history.push(to)} type={type || 'primary'} >
        {children}
    </Link>)
};




// WEBPACK FOOTER //
// ./src/components/scrub/RouteLink.js